import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {NotFoundComponent} from './not-found.component';
import {RouterLink} from '@angular/router';
import {TranslocoPipe} from '@jsverse/transloco';

@NgModule({
  imports: [CommonModule, RouterLink, TranslocoPipe],
  declarations: [NotFoundComponent],
  exports: [NotFoundComponent]
})
export class NotFoundModule {
}
